"use client"

import { CounterBadge } from "@/app/nft/counter/badge"
import { reatomComponent } from "@reatom/react"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { UserBidsMoleculeReatom } from "../user-bids-molecule.reatom"

export const BidsCounterReatom = reatomComponent(() => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <BidsCounterBadgeReatom />
      </Suspense>
    </ErrorBoundary>
  )
}, "BidsCounterReatom")

const BidsCounterBadgeReatom = reatomComponent(() => {
  const { queryParamsAtom } = useMolecule(UserBidsMoleculeReatom)
  // Call atom directly in Reatom v1000
  const queryParams = queryParamsAtom()
  const { data } = useSuspenseInfiniteQuery(queryParams)
  const count = data.pages[0]?.total

  return <CounterBadge count={count} />
}, "BidsCounterBadgeReatom")
